import React from 'react';

export interface SwitchableBusiness {
  id: string;
  name: string;
}

interface IProps {
  selected?: SwitchableBusiness | null;
  businesses: SwitchableBusiness[];
  onSelect: (businessId: string) => void;
  children?: React.ReactNode;
}

const isBusinessForId = (id: string | undefined) =>
  (business: SwitchableBusiness) => business.id.toLowerCase() === id?.toLowerCase();

export default function BusinessSwitcher({ selected, businesses, onSelect, children }: IProps) {
  const isSelected = isBusinessForId(selected?.id);

  return (
    <li className="nav-item dropdown">
      <button
        data-testid="business-switcher"
        className="btn btn-link dropdown-toggle text-decoration-none fw-semibold px-0"
        style={{ '--bs-btn-color': '#71869d', '--bs-btn-hover-color': 'var(--bs-primary)' } as React.CSSProperties}
        data-bs-toggle="dropdown"
        aria-expanded="false">
        {selected?.name ?? 'Select Business'}
      </button>
      <div data-testid="business-switcher-menu" className="dropdown-menu dropdown-nav-menu">
        <span className="dropdown-header">Business</span>
        {businesses.map(business =>
          <button
            className={`btn-ghost-secondary dropdown-item${isSelected(business) ? ' bg-soft-secondary' : ''}`}
            key={business.id}
            onClick={() => onSelect(business.id)}>
            <strong>{business.name}</strong>
          </button>)}
        {children}
      </div>
    </li>
  );
}
